/** @format */

import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import ApiService from "../../services/apiService";
import { toast } from "react-toastify";
import Loader from "../../elements/Loader";
import Pagination from "../../elements/Pagination";

export default function Testimonials() {
    const [testimonials, setTestimonials] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(false);

    const getTestimonialsList = useCallback(async () => {
        setLoading(true);
        try {
            const response = await ApiService.get(`testimonial?page=${currentPage + 1}&limit=10`);
            if (response?.result) {
                setTestimonials(response.result.data);
                setPageCount(response.result.totalPages);
            } else {
                setTestimonials([]);
                setPageCount(0);
            }
        } catch (err) {
            toast.error('Failed to fetch testimonials');
        } finally {
            setLoading(false);
        }
    }, [currentPage]);

    useEffect(() => {
        getTestimonialsList();
    }, [getTestimonialsList]);

    const handlePageClick = (selectedPage) => {
        const clickedPage = selectedPage.selected;
        if (clickedPage !== currentPage) {
            setCurrentPage(clickedPage);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this testimonial?')) {
            try {
                await ApiService.delete(`testimonial/${id}`);
                toast.success('Testimonial deleted successfully');
                getTestimonialsList();
            } catch (err) {
                toast.error('Failed to delete testimonial');
            }
        }
    };

    const truncateText = (text, maxLength = 50) => {
        if (!text) return '';
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    };

    return (
        <div className="row">
            <div className="col-xl-12">
                {loading && <Loader />}
                <div className="card dz-card" id="bootstrap-table2">
                    <div className="card-header flex-wrap d-flex justify-content-between border-0">
                        <div>
                            <h4 className="card-title">Testimonials</h4>
                        </div>
                        <div className="d-flex align-items-center">
                            <Link to="/add-testimonial" className="btn btn-primary ms-3">
                                Add Testimonial
                            </Link>
                        </div>
                    </div>

                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-responsive-md">
                                <thead>
                                    <tr>
                                        <th>
                                            <strong>Sr No.</strong>
                                        </th>
                                        <th>
                                            <strong>Title</strong>
                                        </th>
                                        <th>
                                            <strong>Video URL</strong>
                                        </th>
                                        <th>
                                            <strong>Description</strong>
                                        </th>
                                        <th>
                                            <strong>Action</strong>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {testimonials && testimonials?.length > 0 ? (
                                        testimonials.map((item, key) => (
                                            <tr key={key}>
                                                <td>
                                                    <strong>{currentPage * 10 + key + 1}</strong>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <span className="w-space-no">{item.title}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <a
                                                            href={item.videoUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-primary"
                                                        >
                                                            {truncateText(item.videoUrl, 40)}
                                                        </a>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <span className="w-space-no">{truncateText(item.description, 60)}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <Link
                                                        to={`/edit-testimonial/${item?.id}`}
                                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                                    >
                                                        <i className="fa fa-pencil" />
                                                    </Link>
                                                    <button
                                                        onClick={() => handleDelete(item?.id)}
                                                        className="btn btn-danger shadow btn-xs sharp"
                                                    >
                                                        <i className="fa fa-trash" />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center">
                                                No testimonials found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <Pagination pageCount={pageCount} handlePageClick={handlePageClick} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
